(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[492],{

/***/ 6351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./context/index.js + 4 modules
var context = __webpack_require__(683);
// EXTERNAL MODULE: ./components/common/index.js + 178 modules
var common = __webpack_require__(981);
// EXTERNAL MODULE: ./components/pages/index.js + 71 modules
var pages = __webpack_require__(6188);
// EXTERNAL MODULE: ./lottieAnimation/global/loading.json
var loading = __webpack_require__(7217);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
;// CONCATENATED MODULE: ./styles/pages/BlogIndividualStyle.js

var BlogIndividualStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-rylh5r-0"
})(["--relatedWidth:32.3%;--descWidth:calc(100% - var(--relatedWidth));--lastSectionPadLeft:var(--sp26x);--lastSectionPadRight:var(--sp26-5x);padding-left:var(--lastSectionPadLeft);padding-right:var(--lastSectionPadRight);@media only screen and (max-width:", ") and (min-width:", "){--relatedWidth:34.2%;--lastSectionPadLeft:var(--sp19-5x);--lastSectionPadRight:var(--sp19-5x);}@media only screen and (max-width:", ") and (min-width:", "){--relatedWidth:28.8%;--lastSectionPadLeft:var(--sp14x);--lastSectionPadRight:var(--sp14-5x);}@media only screen and (max-width:", ") and (min-width:", "){--relatedWidth:28.7%;--lastSectionPadLeft:var(--sp10x);--lastSectionPadRight:var(--sp10x);}@media only screen and (max-width:", ") and (min-width:", "){display:block;--relatedWidth:100%;--descWidth:var(--relatedWidth);--lastSectionPadLeft:var(--sp9x);--lastSectionPadRight:var(--sp9x);}@media only screen and (max-width:", ") and (min-width:", "){display:block;--relatedWidth:100%;--descWidth:var(--relatedWidth);--lastSectionPadLeft:var(--sp4-5x);--lastSectionPadRight:var(--sp4-5x);}@media only screen and (max-width:", "){display:block;--relatedWidth:100%;--descWidth:var(--relatedWidth);--descWidth:var(--relatedWidth);--lastSectionPadLeft:var(--sp2x);--lastSectionPadRight:var(--sp2x);}"], function (props) {
  return props.theme.mediaQuery.DesktopSizeLMin;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeM;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeMMin;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeS;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeSMin;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeXS;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeXSMin;
}, function (props) {
  return props.theme.mediaQuery.LaptopSize;
}, function (props) {
  return props.theme.mediaQuery.LaptopSizeMin;
}, function (props) {
  return props.theme.mediaQuery.TabletSize;
}, function (props) {
  return props.theme.mediaQuery.TabletSizeMin;
});
/* harmony default export */ var pages_BlogIndividualStyle = (BlogIndividualStyle);
// EXTERNAL MODULE: ./styles/pages/BlogStyle.js
var BlogStyle = __webpack_require__(1881);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./pages/blog/[slug]/index.js
 // * Context

 //* Components



 //! Style





var BlogIndividual = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var _pageData$post, _pageData$post2, _pageData$post3, _pageData$relatedPost;

  var singleBlog = _ref.singleBlog,
      pageParams = _ref.pageParams,
      selectedLang = _ref.selectedLang;
  var pageData = (0,react.useMemo)(function () {
    var _singleBlog$pageParam;

    return singleBlog === null || singleBlog === void 0 ? void 0 : (_singleBlog$pageParam = singleBlog[pageParams.selectedSlug]) === null || _singleBlog$pageParam === void 0 ? void 0 : _singleBlog$pageParam[selectedLang];
  }, [singleBlog, pageParams, selectedLang]);
  return pageData ? /*#__PURE__*/(0,jsx_runtime.jsxs)(common/* Page */.T3, {
    meta: (_pageData$post = pageData.post) === null || _pageData$post === void 0 ? void 0 : _pageData$post.meta,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(pages/* TitleSection */.Qb, {
      title: (_pageData$post2 = pageData.post) === null || _pageData$post2 === void 0 ? void 0 : _pageData$post2.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(pages/* IndividualHeroSection */.Ls, {
      postData: pageData.post
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(pages_BlogIndividualStyle, {
      className: "FlexBox",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(pages/* InfoSection */.we, {
        infoData: (_pageData$post3 = pageData.post) === null || _pageData$post3 === void 0 ? void 0 : _pageData$post3.description
      }), ((_pageData$relatedPost = pageData.relatedPosts) === null || _pageData$relatedPost === void 0 ? void 0 : _pageData$relatedPost.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(pages/* RelatedSection */.$q, {
        relatedData: pageData.relatedPosts
      }) : '']
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(BlogStyle/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Page */.T3, {
      className: "lottieSection FlexBox AlignCenter AlignMiddle",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* LottieAnimation */.Fm, {
        animData: loading,
        isPlay: true,
        autoplay: true,
        loop: true
      })
    })
  });
});
/* harmony default export */ var _slug_ = ((0,context/* withDataContext */.hX)(BlogIndividual, ['singleBlog']));

/***/ }),

/***/ 2768:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(6351);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [522,188,335,774,888,179], function() { return __webpack_exec__(2768); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);